import { AnimatedProgressIndicator, ErrorStatus, Hidden } from '@sas/react-svg';
import cx from 'classnames';
import { createUseTextLocalizer } from '../../locale/createUseTextLocalizer';
import { renderInlineCssVars, useDesignTokens } from '../../theme';
import { Icon } from '../Icon';
import { GlobalSettingsKeys, useGetGlobalSetting } from '../Settings';
import bundle from './NovaComponents-Indicator-gui-icu.properties';
import cn from './Indicator.css.json';
import './Indicator.css';
import { jsx as _jsx } from "react/jsx-runtime";
const useTextLocalizer = createUseTextLocalizer(bundle);
const BaseIndicator = props => {
  return /*#__PURE__*/_jsx("span", {
    "aria-hidden": "true",
    className: cx(cn.container, props.className),
    "data-testid": props.testId,
    style: props.style,
    children: props.content
  });
};
export const Indicator = ({
  className,
  count,
  testId,
  type,
  ...props
}) => {
  const playVisualEffects = useGetGlobalSetting(GlobalSettingsKeys.PLAY_VISUAL_EFFECTS) === 'true';
  const dt = useDesignTokens();
  const tokens = {
    ...renderInlineCssVars(getIndicatorTokens(dt, playVisualEffects), 'indicator')
  };
  const style = {
    ...tokens,
    ...props.style
  };
  const localize = useTextLocalizer();
  const defaultMaxDigits = 3;
  const maxDigits = !!props.maxDigits && props.maxDigits > 0 && props.maxDigits <= 3 ? props.maxDigits : defaultMaxDigits;
  const maxValue = Math.pow(10, maxDigits);
  // Used for calculating and displaying the '+' sign for large count value
  const countValue = count !== undefined && count < maxValue ? count : `${maxValue - 1}+`;
  switch (type) {
    case 'processing':
      return /*#__PURE__*/_jsx(BaseIndicator, {
        className: className,
        content: /*#__PURE__*/_jsx(Icon, {
          className: cn.processing,
          icon: AnimatedProgressIndicator,
          tooltip: localize('processing.label'),
          color: "informational"
        }),
        style: style,
        testId: testId
      });
    case 'alert':
      return /*#__PURE__*/_jsx(BaseIndicator, {
        className: cx(cn.alert, className),
        content: "!",
        style: style,
        testId: testId
      });
    case 'unsaved':
      return /*#__PURE__*/_jsx(BaseIndicator, {
        className: className,
        content: "*",
        style: style,
        testId: testId
      });
    case 'readOnly':
      return /*#__PURE__*/_jsx(BaseIndicator, {
        className: className,
        content: localize('readOnly.label'),
        style: style,
        testId: testId
      });
    case 'hidden':
      return /*#__PURE__*/_jsx(BaseIndicator, {
        className: cx(cn.hidden, className),
        content: /*#__PURE__*/_jsx(Icon, {
          icon: Hidden,
          tooltip: props.tooltip ?? localize('hidden.label')
        }),
        style: style,
        testId: testId
      });
    case 'ready':
      return /*#__PURE__*/_jsx(BaseIndicator, {
        className: cx(cn.ready, className),
        content: "\u2022",
        style: style,
        testId: testId
      });
    case 'count':
      return count !== undefined ? /*#__PURE__*/_jsx(BaseIndicator, {
        className: cx(cn.count, className),
        content: `${countValue}`,
        style: style,
        testId: testId
      }) : null;
    case 'error':
      return /*#__PURE__*/_jsx(BaseIndicator, {
        className: className,
        content: /*#__PURE__*/_jsx(Icon, {
          icon: ErrorStatus,
          tooltip: props.tooltip
        }),
        style: style,
        testId: testId
      });
  }
};
const getIndicatorTokens = (dt, playVisualEffects) => {
  return {
    'processing-anim-duration': dt.tokens['duration-700'],
    'processing-anim-iteration-count': playVisualEffects ? 'infinite' : 0,
    'alert-fg': dt.tokens['color-status-icon-alert'],
    'hidden-fg': dt.tokens['color-body-icon'],
    'ready-fg': dt.tokens['color-status-text-info'],
    fg: dt.tokens['color-body-text'],
    'font-size-m': dt.tokens['font-size-body-text-m'],
    'count-fg': dt.tokens['color-text-neutral-inverse'],
    'count-bg': dt.tokens['color-status-icon-neutral'],
    'count-font-size': dt.tokens['font-size-body-text-xxxs'],
    'count-bd-radius': dt.tokens['size-border-radius-s'],
    'count-padding': dt.tokens['space-base-xs']
  };
};
//# sourceMappingURL=Indicator.js.map